import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { addDays, addSeconds, addMinutes, addHours, endOfDay, startOfMonth, endOfMonth, isSameDay, isSameMonth, startOfDay, subDays } from 'date-fns';

import { AuthService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
//import { SharedModule } from '../../../shared.module';
import { UscModalComponent } from '../usc-modal/usc-modal.component';
import { UscFirstComponent } from '../usc-first/usc-first.component';
import { UscMiddleComponent } from '../usc-middle/usc-middle.component';
import { UscLastingComponent } from '../usc-lasting/usc-lasting.component';
import { User } from '../../../models';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { UscTimeslotPickerComponent } from '../usc-timeslot-picker/usc-timeslot-picker.component';
import { UscUserLookupComponent } from '../usc-user-lookup/usc-user-lookup.component';
//import { Input } from '@angular/core/src/metadata/directives';

@Component({
    selector: 'sn-usc-search',
    templateUrl: './usc-search.component.html',
    styleUrls: ['../usc-store.component.css', './usc-search.component.css']
})
export class UscSearchComponent implements OnInit {
    name: string = 'usc-search';
    view: string = this.uscStoreService.view_search;
    @Input() searchText: string;
    @Input() showAcceptAppointment: boolean;
    @Input() itemID: number = 0;      // this can only be set by navigate from the calendar, which allow associates to claim a Same-Day appointment lead

    user: User;

    // month names
    public month_names = ["(JAN)", "(FEB)", "(MAR)", "(APR)", "(MAY)", "(JUN)", "(JUL)", "(AUG)", "(SEP)", "(OCT)", "(NOV)", "(DEC)"];
    // leader access
    loading: boolean = true;
    public isLeader: boolean = false;
    itemResource: DataTableResource<any> = null;
    // dataSource:MatTableDataSource<any> = null;
    public isUSCellRetail: boolean = false;
    public isUSCellCorp: boolean = false;
    public isUSCellAgent: boolean = false;
    public isUSCellInsideSales: boolean = false;
    public isUSCellTelesales: boolean = false;

    items = [];
    itemCount = 0;
    curPage = 1;
    pageSize = 20;
    pageCount = 0;
    orderBy = "dl_name";
    asc: boolean = true;
    data_filter = {
        u_user_ID: [],
        u_team_ID: [],
        // cfd_cm: [],
        cm_name: [],
    }

    current_filter = {
        owner: { label: "", value: "" },
        team: { label: "", value: "" },
        campaign: { label: "All Campaigns", value: "" }
    }

    public sortable_header_classes = {
        co_lastname: "sn_header sn_sortable active",
        co_firstname: "sn_header sn_sortable",
        co_work_phone1: "sn_header sn_sortable",
        // cfd_cm: "sn_header sn_sortable",
        cm_name: "sn_header sn_sortable",
        cfd_cp1: "sn_header sn_sortable"
    }

    constructor(
        private authService: AuthService,
        private uscStoreService: UscStoreService,
        private ngbModal: NgbModal,
        private ngbActiveModal: NgbActiveModal
    ) {
    }

    ngOnInit() {
        this.authService.currentUser.subscribe(
            currentUser => {
                this.user = currentUser;
                this.isUSCellRetail = this.uscStoreService.isUSCellRetail();
                this.isUSCellCorp = this.uscStoreService.isUSCellCorp();
                this.isUSCellAgent = this.uscStoreService.isUSCellAgent();
                this.isUSCellInsideSales = this.uscStoreService.isUSCellInsideSales();
                this.isUSCellTelesales = this.uscStoreService.isUSCellTelesales();
            }
        );

        this.loadItems();
        this.isLeader = this.uscStoreService.isLeader();
    }

    getSearchParams() {
        var params: any = {}
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.orderBy;
        if (this.itemID > 0) {
            params.idList = this.itemID.toString();
        } else {
            params.text = this.searchText;
        }
        params.obd = this.asc ? "asc" : "desc";
        var filter = [
            { field: "u_user_ID", op: "=", value: this.current_filter.owner.value.length > 0 ? this.current_filter.owner.value : null },
            { field: "u_team_ID", op: "=", value: this.current_filter.team.value.length > 0 ? this.current_filter.team.value : null },
            // { field: "cfd_cm", op: "=", value: this.current_filter.campaign.value.length > 0 ? this.current_filter.campaign.value : null  },
            { field: "cm_name", op: "=", value: this.current_filter.campaign.value.length > 0 ? this.current_filter.campaign.value : null }
        ];

        params.f = JSON.stringify(filter);
        return params;
    }

    loadItems() {
        console.log("loadItems");
        this.loadMetaData();
        this.reloadItems();
    }

    loadMetaData() {
        console.log("loadMetaData");
        var params = this.getSearchParams();
        this.uscStoreService.getMetaData(this.view, params).subscribe(result => {
            this.data_filter = result.meta_data.data_filter;
        },
            err => {
                console.log(err)
            }
        );
    }

    reloadItems() {
        console.log("reloadItems");
        this.loading = true;
        var params = this.getSearchParams();
        this.uscStoreService.getData(this.view, params).subscribe(
            result => {
                this.itemResource = new DataTableResource(result.items);
                this.items = result.items;
                this.itemCount = result.total_count;
                this.pageCount = Math.ceil(this.itemCount / this.pageSize);
                this.loading = false;
                // if itemID > 0, we should show "Accept Appt" 
                // but if the owner of the lead is not a Store, the lead may have already been Claimed by another associate
                // let's change itemID = 0 so we will show "Save to Middle" instead
                //if (this.itemID > 0 && result.items.length == 1 && result.items[0].u_title != 'Store') this.itemID = 0;
            },
            err => {
                console.log(err)
            }
        );
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            this.reloadItems();
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            this.reloadItems();
        }
    }

    sort(orderBy: string, e) {
        this.orderBy = orderBy;
        this.asc = !this.asc;
        for (var p in this.sortable_header_classes) {
            this.sortable_header_classes[p] = "sn_header sn_sortable";
            if (p == orderBy) {
                this.sortable_header_classes[p] = "sn_header sn_sortable active";
            }
        }
        this.reloadItems();
    }

    filter(column, filter) {
        console.log(column);
        console.log(filter);
        switch (column) {
            case 'u_user_ID': this.current_filter.owner = filter || { label: "", value: "" }; break;
            case 'u_team_ID': this.current_filter.team = filter || { label: "", value: "" }; break;
            // case 'cfd_cm': this.current_filter.campaign = filter || { label: "All Campaigns", value: "" }; break;
            case 'cm_name': this.current_filter.campaign = filter || { label: "All Campaigns", value: "" }; break;
        }
        this.reloadItems();
    }

    goToLead(event, item) {
        this.uscStoreService.setGotoItem(item);
    }

    createNewLead(bApplySearchText: boolean = true) {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.uscStoreService.form_lasting_impression;   // default to lasting impression on new lead
        modalRef.componentInstance.openCustomInputEvent = this.openCustomInputDialog;
        let new_lead = { dl_ID: 0, co_work_phone1: null, co_firstname: null, co_lastname: null, dl_notes: null };
        if (bApplySearchText) {
            let name_fields = ['co_firstname', 'co_lastname'];
            let name_index = 0;
            let tokens: Array<any> = this.searchText.split(' ');
            // parse search text to form a new lead, take the first numeric string as phone#
            // take the first string as firstname, and second string as lastname
            tokens.forEach(
                t => {
                    var token = t.replace(/\D/g, '');
                    if (token.length > 0) {
                        new_lead.co_work_phone1 = t;
                    } else if (name_index < 2) {
                        new_lead[name_fields[name_index]] = t;
                        name_index++;
                    }
                }
            )
        }
        modalRef.componentInstance.data = new_lead;
        modalRef.result.then((result) => {
            console.log(result);
            let item: any = {};

            result.data.forEach(f => {
                if (f["key"] == "dl_type") {
                    item.dl_type = f["value"];
                } else if (f["key"] == "dl_ID") {
                    item.dl_ID = f["value"];
                    item.view_ID = item.dl_ID;
                } else if (f["key"] == "tsns") {
                    item.tsns = f["value"];
                }
            });

            var bCalendarApptCreated = false;
            var bPromptSameDayAlert = false;
            if (this.isUSCellRetail) {
                var cfd_fumd = result.data.find(d => d.key == 'cfd_fumd');
                if (cfd_fumd && result.event == this.uscStoreService.form_response_save_to_middle) {
                    bCalendarApptCreated = true;
                    var date = new Date(cfd_fumd.value); // this will convert date value to localtime 
                    var today = new Date();
                    // compare UTC string to today instead due to javascript converts to localtime 
                    if (date.getUTCFullYear() == today.getFullYear() && date.getUTCMonth() == today.getUTCMonth() && date.getUTCDate() == today.getDate()) {
                        bPromptSameDayAlert = true;
                    }
                }
            }

            if (bCalendarApptCreated) this.uscStoreService.reloadCalendarEvents(result.event);
            if (bPromptSameDayAlert) {
                this.openOkDialog('Please alert other Associates within your store that you have booked a same-day appointment.', result, item, true);
            } else {
                switch (result.event) {
                    case this.uscStoreService.form_response_save_to_first: this.uscStoreService.setCurrentView(this.uscStoreService.view_first); break;
                    case this.uscStoreService.form_response_save_to_middle: this.uscStoreService.setGotoItem(item); break;
                    case this.uscStoreService.form_response_save_and_new: this.createNewLead(false); break;
                    case this.uscStoreService.form_response_save_purchase: this.showOutcomeLog(item, this.uscStoreService.form_future_sale); break;
                }
            }
        }, (reason) => {
            console.log(reason);
        });
    }

    handleSaveResponse(result, item) {
        switch (result.event) {
            case this.uscStoreService.form_response_save_to_first: this.uscStoreService.setCurrentView(this.uscStoreService.view_first); break;
            case this.uscStoreService.form_response_save_to_middle: this.uscStoreService.setGotoItem(item); break;
            case this.uscStoreService.form_response_save_and_new: this.createNewLead(false); break;
            case this.uscStoreService.form_response_save_purchase: this.showOutcomeLog(item, this.uscStoreService.form_future_sale); break;
        }
    }

    showOutcomeLog(item, outcome) {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = outcome;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.openCustomInputEvent = this.openCustomInputDialog;
        modalRef.result.then((result) => {
            console.log(result);
            // create a dummy item to GOTO
            let item: any = {};
            // assume come from future purchase
            if (result.data.length > 0) {
                for (var i = 0; i < result.data.length; i++) {
                    var d = result.data[i];
                    if (d["key"] == "dl_type") {
                        item.dl_type = d["value"];
                    } else if (d["key"] == "dl_ID") {
                        item.dl_ID = d["value"];
                    }
                }
                this.uscStoreService.setGotoItem(item);
            } else if (result.data) {
                for (var p in result.data) {
                    if (p["key"] == "dl_type") {
                        item.dl_type = p["value"];
                    } else if (p["key"] == "dl_ID") {
                        item.dl_ID = p["value"];
                    }
                }
                this.uscStoreService.setGotoItem(item);
            } else {
                this.reloadItems();
            }
        }, (reason) => {
            console.log(reason);
        });
    }

    public openCustomInputDialog(formValues, field) {
        if (field.key == "cfd_fumts2" || field.key == "cfd_fumts") {
            var modal = this.ngbModal.open(UscTimeslotPickerComponent, { size: "lg", backdrop: 'static', keyboard: false });
            modal.componentInstance.schedule_date = new Date(formValues.cfd_fumd);
            modal.componentInstance.view_ID = formValues.dl_ID;
            // if (this.uscStoreService.isQueuingModuleAccessEnabled()) modal.componentInstance.scheduling_mode = "sn";
            return modal;
        }
        return null;
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    saveToMiddle(event, item) {
        let dlg = this.showCustomPromptDlg(item, { msg: "Saving to Middle" });
        this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_save_to_middle, "").subscribe(
            result => {
                // console.log(result);
                dlg.dismiss();
                if (result) {
                    this.uscStoreService.setTriggerChatItemReload();                          // trigger chat reload in case the deal is being restored from archive
                    this.uscStoreService.setViewItemUpdated(item, true);                      // trigger deal update for chat to get the latest changes
                    let goToItem: any = { dl_type: result.data.type, dl_ID: result.data.ID };
                    this.uscStoreService.setGotoItem(goToItem);
                }
            }
        );
    }

    acceptAppointment(event, item, assignee_ID = 0, dlg = null) {
        if (this.isUSCellAgent && this.user.title == 'Store' && item.u_title == 'Store' && item.dl_account_type == '') {
            this.editAssociate(item);
        } else {
            if (dlg == null) dlg = this.showCustomPromptDlg(item, { msg: "Accepting Lead" });
            var params = assignee_ID > 0 ? { owner_ID: assignee_ID } : "";
            this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_accept_appointment, params).subscribe(
                result => {
                    // console.log(result);
                    if (dlg) dlg.dismiss();
                    if (result) {
                        this.uscStoreService.setTriggerChatItemReload();                          // trigger chat reload in case the deal is being restored from archive
                        this.uscStoreService.setViewItemUpdated(item, true);                      // trigger deal update for chat to get the latest changes
                        let goToItem: any = { dl_type: result.data.type, dl_ID: result.data.ID };
                        this.uscStoreService.setGotoItem(goToItem);
                    }
                }
            );
        }
    }

    assignAppointment(event, item) {
        const modalRef = this.ngbModal.open(UscUserLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.lookup_scope = "user_team";
        modalRef.result.then((result) => {
            console.log(result);
            let dlg = this.showCustomPromptDlg({}, { msg: "Assigning Appointment" });
            var params = { idList: item.view_ID.toString(), user_ID: result.selectedItem.ID };
            this.acceptAppointment(null, item, result.selectedItem.ID, dlg);
        }, (reason) => {
            console.log("User Lookup Closed");
        });
    }

    getDateMonthName(dl_datetime_created: string) {
        let datetime_created = new Date(Date.parse(dl_datetime_created));
        datetime_created.setHours(datetime_created.getHours() - 8);
        return this.month_names[datetime_created.getMonth()];
    }


    showCampaignMonth(item): boolean {
        switch (item.cm_name) {
            case 'Associate':
            case 'Walk-In':
            case 'Referral':
            case 'GRO':
            case 'Sponsorship':
                return true;
        }
        return false;
    }

    allowGotoLead(item) {
        if (this.uscStoreService.isUSCellRetail() && this.itemID > 0) return false;
        if (this.uscStoreService.isUSCellTelesales() && this.itemID > 0) return false;
        var bAllow = false;
        if (!this.isLeadArchived(item) && this.user) {
            var bIsOwner = this.user.username == item.u_username;                               // ownership
            var bLeaderAccess = this.uscStoreService.isLeader && item.leader_access == "Yes";   // leader access
            bAllow = bIsOwner || bLeaderAccess;
        }
        return bAllow;
    }

    allowSaveToMiddle(item) {
        if (this.uscStoreService.isUSCellRetail() && this.itemID > 0) return false;
        if (this.uscStoreService.isUSCellTelesales() && this.itemID > 0) return false;
        return this.isLeadArchived(item) || (this.user && this.user.username != item.u_username);
    }

    // if itemID > 0, it must be coming from the calendar. the lead must also be owned by a store 
    allowAcceptAppointment(item) {
        if (this.uscStoreService.isUSCellRetail() && this.itemID > 0) return true;
        if (this.uscStoreService.isUSCellTelesales() && this.itemID > 0) return true;
        return false;
    }

    allowAssignAppointment(item) {
        if (this.uscStoreService.isUSCellRetail() && this.itemID > 0) return this.uscStoreService.isLeader();
        if (this.uscStoreService.isUSCellTelesales() && this.itemID > 0) return this.uscStoreService.isLeader();
        return false;
    }

    isLeadArchived(item) {
        return item.dl_stage == 'Archive';
    }

    getScheduledMeetingDateText(item) {
        var scheduled_date = this.getScheduledDateFromMeeting(item);
        return scheduled_date ? this.getScheduledDateText(scheduled_date) : "";
    }

    // convert calendar event into text value
    getScheduledDateText(date) {
        var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        if (date) {
            var hours = date.getHours();
            var tt = (hours >= 12) ? "PM" : "AM";
            if (hours > 12) hours -= 12;
            var minutes: any = date.getMinutes();
            minutes = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
            var month: any = date.getMonth() + 1;
            month = month < 10 ? "0" + month.toString() : month.toString();
            var date_num: any = date.getDate();
            date_num = date_num < 10 ? "0" + date_num.toString() : date_num.toString();
            return `${days[date.getDay()]} ${date.getFullYear()}-${month}-${date_num} ${hours}:${minutes} ${tt}`;
        }
        return "";
    }

    getScheduledEventdate(item) {
        return !this.isUSCellRetail ? this.getScheduledDate(item.cfd_fucd, item.cfd_fucts) : this.getScheduledDateFromMeeting(item);
    }

    getScheduledDateFromMeeting(item) {
        var cfd_timeslot = item.cfd_fumts;
        if (cfd_timeslot && item.me_date) {
            var scheduled_date = new Date(item.me_date);
            scheduled_date.setHours(0, 0, 0);
            var start_time = cfd_timeslot.split('-')[0];
            var hours = parseInt(start_time.substring(0, start_time.indexOf(':')));
            var minutes = parseInt(start_time.substring(start_time.indexOf(':') + 1, start_time.indexOf(':') + 3));
            if (hours != 12) hours += start_time.indexOf("PM") >= 0 ? 12 : 0;
            scheduled_date = addMinutes(scheduled_date, hours * 60 + minutes);
            return scheduled_date;
        }
        return null;
    }

    // rough date conversion 
    getScheduledDate(cfd_date, cfd_timeslot) {
        if (cfd_date && cfd_timeslot) {
            var scheduled_date = new Date((new Date(cfd_date)).setHours(0, 0, 0));
            var start_time = cfd_timeslot.split('-')[0];
            var hours = parseInt(start_time.substring(0, start_time.indexOf(':')));
            var minutes = parseInt(start_time.substring(start_time.indexOf(':') + 1, start_time.indexOf(':') + 3));
            if (hours != 12) hours += start_time.indexOf("PM") >= 0 ? 12 : 0;
            scheduled_date = addMinutes(scheduled_date, hours * 60 + minutes);
            return scheduled_date;
        }
        return null;
    }

    getEventOverdueClass(item) {
        var secheduled_date = this.getScheduledEventdate(item);
        if (secheduled_date) {
            let now = new Date();
            return (secheduled_date.getTime() < now.getTime()) ? "usc_event_overdue" : "";
        }
        return "";
    }

    isFirstImpression() { return this.view == this.uscStoreService.view_first; }
    isMiddleImpression() { return this.view == this.uscStoreService.view_middle; }
    isLastingImpression() { return this.view == this.uscStoreService.view_lasting; }


    editAssociate(item) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_edit_associate;

        modalRef.result.then((result) => {
            var params = { dl_account_type: result.associate };
            let dlg = this.showCustomPromptDlg(item, { msg: "Updating Associate" });
            this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_update_associate, params).subscribe(
                result => {
                    dlg.dismiss();
                    let goToItem: any = { dl_type: item.dl_type, dl_ID: item.dl_ID };
                    // let goToItem:any = { dl_type: result.data.type, dl_ID: result.data.ID  };
                    this.uscStoreService.setGotoItem(goToItem);
                    //this.reloadItems(); 
                }
            );
        });
    }

    // helper methods - begin
    public openOkDialog(message, result, item, bReloadItem) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_ok_prompt;
        modalRef.componentInstance.msg_config = { msg: message };
        modalRef.result.then((result) => {
            if (bReloadItem) this.handleSaveResponse(result, item);
        }, (reason) => {
            if (bReloadItem) this.handleSaveResponse(result, item);
        });
    }
    // helper methods - end  
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-search/usc-search.component.ts